import { getThemeColor } from '@design/design-tokens/themes/theme-utils';
import { DesignToken, ThemeName } from '@design/design-tokens/themes/themes';
import { hexToRgba } from '@design/utils/color-conversion/color-conversion';

import { PieChartData } from './PieChart';

export const getColors = (theme: ThemeName) => {
  const normalColors = Array.from({ length: 5 }, (_, i) =>
    getThemeColor(`--chart-multi-lines-hex-${i + 1}` as DesignToken, theme)
  );

  return normalColors;
};

export const createPieSeries = (
  data: PieChartData,
  theme: ThemeName,
  {
    solid = false,
    disableHover = false,
  }: { solid?: boolean; disableHover?: boolean } = {}
) => {
  const normalColors = getColors(theme);
  return [
    {
      top: 'top',
      center: ['50%', '48%'],
      type: 'pie',
      silent: disableHover,
      radius: solid ? '100%' : ['60%', '95%'],
      label: { show: false },
      itemStyle: {
        borderColor: getThemeColor('--border-soft', theme),
        borderWidth: 1,
      },
      emphasis: {
        focus: 'self',
        scale: false,
      },
      blur: {
        itemStyle: { opacity: 1 },
      },
      labelLine: { show: false },
      data: data.map(({ color: colorOverride, ...item }, idx) => {
        const color = colorOverride
          ? getThemeColor(colorOverride, theme)
          : normalColors[idx % normalColors.length];

        return {
          ...item,
          itemStyle: {
            color,
          },
          emphasis: {
            itemStyle: {
              color,
            },
          },
          blur: {
            itemStyle: {
              color: hexToRgba({ hex: color, alpha: 0.15 }),
            },
          },
        };
      }),
    },
  ];
};
